module.exports = __webpack_public_path__ + "img/kr-product-ecmy-card2-img1.5d71d7a.png";